import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

export const ReturnToProductText = () => (
	<FormattedMessage
		id="return-to-product-modal.header.text"
		defaultMessage="Pick up where you left off."
	/>
);

/**
 @deprecated use ReturnToProductText with Headings component instead
 */
export const ReturnToProductSubheading = () => (
	<p css={subHeaderCss}>
		<ReturnToProductText />
	</p>
);

const subHeaderCss = css({
	margin: '0 auto',
	textAlign: 'center',
});
